import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/woocommerce/banner-woocommerce.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service healthcare_banner android_banner chatbot_banner ecomm_web_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={8} xl={8} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                WooCommerce Web Development Company
              </h1>
              <span>Custom, High-Performance Retail Websites</span>
              <p style={{ marginTop: "10px" }}>
                Get your WooCommerce site up and running with our expert team.
                We deliver custom themes, efficient plugin integration, and
                performance optimization. Our developers ensure secure, scalable
                builds with minimal downtime. Choose our WooCommerce web design
                agency for precise, high-performance solutions that streamline
                the user experience and boost conversions.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Build WooCommerce Website
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
